
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import en from './en';

export default {
  translation: {
    ...en.translation,
    header_title: "Constantina",
    nav_shopping_assistant: "Asistente de Compras",
    nav_assistant_short: "Asistente",
    "nav_style_lab": "Style Lab",
    nav_studio: "Style Studio",
    nav_tryon: "Probador Virtual",
    nav_actions_title: "Acciones",
    portfolio_instagram_connect_title: 'Conectar en Instagram',
    "shoppingAssistant_title": "Asistente de Compras",
    "shoppingAssistant_subtitle": "Impulsado por IA",
    "shoppingAssistant_greeting": "¡Hola! Soy tu asistente de compras con IA. ¿En qué puedo ayudarte hoy? Puedes pedirme que busque productos, verifique el estado de tu pedido o te ayude con las devoluciones.",
    "shoppingAssistant_error_connection": "Lo siento, tengo problemas para conectarme en este momento.",
    "shoppingAssistant_history_cleared": "Historial borrado. ¿Cómo puedo ayudarte hoy?",
    "shoppingAssistant_clear_history": "Borrar conversación",
    "shoppingAssistant_close": "Cerrar asistente",
    "shoppingAssistant_role_assistant": "Asistente",
    "shoppingAssistant_copy_caption": "Copier subtítulo",
    "shoppingAssistant_social_media_title": "Subtítulos para redes sociales generados por IA",
    "shoppingAssistant_save_to_advice": "Guardar en Consejos",
    "shoppingAssistant_select_slot": "Seleccionar",
    "shoppingAssistant_thinking": "El asistente está pensando...",
    "shoppingAssistant_input_placeholder": "Buscar productos, rastrear pedidos...",
    "shoppingAssistant_send_aria": "Enviar mensaje",
    "shoppingAssistant_suggest_summer_dresses": "Vestidos de verano",
    "shoppingAssistant_suggest_track_order": "Rastrear pedido",
    "shoppingAssistant_suggest_return_policy": "Política de devoluciones",
    "shoppingAssistant_response_products": "He encontrado algunos {{category}} que podrían gustarte:",
    "shoppingAssistant_response_order_status": "Aquí está el estado de tu pedido {{orderId}}:",
    "shoppingAssistant_response_order_not_found": "No he podido encontrar ese pedido. Por favor, verifica el ID del pedido e inténtalo de nuevo.",
    "shoppingAssistant_response_return_policy": "Nuestra política de devoluciones permite devolver artículos dentro de los 30 días posteriores a la entrega. Los artículos deben estar sin usar y en su embalaje original. ¿Te gustaría iniciar una devolución para un pedido específico?",
    "shoppingAssistant_response_social_media": "¡He redactado algunos subtítulos personalizados para redes sociales basados en tu look actual! ¿Cuál te gusta más?",
    "shoppingAssistant_response_social_no_garment": "¡Me encantaría ayudarte con una publicación! ¿Podrías seleccionar primero una prenda en el probador para que tenga algo sobre lo que escribir?",
    "shoppingAssistant_response_booking": "Definitivamente puedo ayudarte a reservar una sesión de estilismo profesional. ¿Cuándo tenías pensado?",
    "shoppingAssistant_service_styling_consultation": "Consulta de Estilismo Personal",
    "shoppingAssistant_response_wardrobe_matches": "He encontrado algunas combinaciones en tu armario, además de algunas piezas de nuestro catálogo para completar el look:",
    "shoppingAssistant_response_retail_matches": "Basado en tus preferencias de estilo, he encontrado estos artículos para ti:",
    "shoppingAssistant_response_greeting": "¡Hola! Soy tu asistente personal de estilo y compras. Puedo ayudarte a encontrar productos (en nuestra tienda o en tu armario), crear publicaciones en redes sociales para tus looks o reservar una consulta. ¿En qué puedo ayudarte hoy?",
    "shoppingAssistant_response_fallback": "¡Estoy aquí para ayudarte con tu estilo! Puedes pedirme que busque productos, cree publicaciones sociales o te dé consejos de moda.",
    "shoppingAssistant_order_status_label": "Estado del pedido",
    "shoppingAssistant_order_id_label": "ID del pedido",
    "shoppingAssistant_order_date_label": "Fecha",
    "shoppingAssistant_order_items_label": "Artículos",
    "shoppingAssistant_order_total_label": "Monto total",
    "shoppingAssistant_order_est_delivery_label": "Entrega estimada",
    "shoppingAssistant_order_track_cta": "Rastrear paquete",
    "shoppingAssistant_order_status_shipped": "Enviado",
    "shoppingAssistant_order_status_delivered": "Entregado",
    "shoppingAssistant_order_status_processing": "Procesando",
    "shoppingAssistant_product_in_wardrobe": "En tu armario",
    "shoppingAssistant_product_low_stock": "Stock bajo",
    "shoppingAssistant_product_price_wardrobe": "ARMARIO",
    "shoppingAssistant_product_add_to_basket": "Añadir al carrito",
    "shoppingAssistant_product_owned": "Propiedad",
    "shoppingAssistant_product_already_in_wardrobe": "Ya en tu armario",
    portfolio_instagram_connect_desc: 'Sigue nuestras historias de estilo diarias, contenido detrás de escena y funciones de la comunidad.',
    common_connect: 'Conectar',
    voucher_title: "Tarjetas Regalo",
    voucher_cta: "Comprar Bono",
    voucher_tagline: "Regala estilo.",
    portfolio_feature_color_analysis: "Análisis de Color",
    portfolio_feature_all_complete_features: "Todas las características del paquete completo",
    trends_page_subtitle: "Lo Actual",
    trends_page_title: "Tendencias de Moda",
    trends_page_description: "Descubre las últimas tendencias de moda seleccionadas para tu generación.",
    trends_filter_all: "Todas las Generaciones",
    portfolio_video_views: 'Vistas',
    colorStudio_title: "Estudio de análisis de color",
    feature_locked_guest: "Función bloqueada (Invitado)",
    upgrade_membership: "Mejorar membresía",
    shoppingAssistant_membership_locked: "El Asistente de compras está disponible para nuestros miembros Premium y Advanced.",
    view_plans: "Ver planes",
    colorStudio_premium_required: "Desbloquea el análisis de color estacional personalizado y las recomendaciones de paleta. Disponible para miembros Premium y Advanced.",
    colorStudio_subtitle: "Desbloquea el poder del color. Descubre los tonos que armonizan con tu tono de piel, cabello y ojos únicos.",
    colorStudio_powerColors_desc: "Los colores clave que realzan tu belleza.",
    colorAnalysis_title: "Análisis de color",
    colorAnalysis_confirm_new: "Ya tienes un análisis de color en tu perfil. ¿Te gustaría realizar uno nuevo basado en detección de imagen?",
    colorAnalysis_analyze_new: "Analizar nueva foto",
    colorAnalysis_analyzing: "Analizando tus colores...",
    colorAnalysis_analyzing_subtext: "Determinando estación, tono de piel y contraste.",
    colorAnalysis_upload_title: "Subir foto",
    colorAnalysis_upload_btn: "Seleccionar imagen",
    colorAnalysis_season_label: "Tu estación",
    colorAnalysis_characteristic_skin: "Piel:",
    colorAnalysis_characteristic_contrast: "Contraste:",
    colorAnalysis_characteristic_eyes: "Ojos:",
    colorAnalysis_characteristic_hair: "Cabello:",
    colorAnalysis_powerColors: "Colores poderosos",
    colorAnalysis_neutrals: "Tonos neutros",
    colorAnalysis_avoid: "Colores a evitar",
    colorAnalysis_advice_hair_makeup: "Cabello y maquillaje",
    colorAnalysis_advice_clothing: "Consejos de vestimenta",
    colorAnalysis_error: "El análisis falló.",
    colorAnalysis_no_result_title: "Aún no hay análisis de color",
    colorAnalysis_no_result_desc: "Sube una foto o selecciona un atuendo guardado para descubrir tu temporada de colores personal y tu paleta.",
    colorAnalysis_start_button: "Iniciar mi análisis de color",
    colorAnalysis_label_hair: "Cabello",
    colorAnalysis_label_makeup: "Maquillaje",
    colorAnalysis_label_jewelry: "Joyería",
    colorAnalysis_saved_to_profile: "Guardado en el perfil",
    colorAnalysis_save_to_profile: "Guardar análisis en el perfil",
    colorAnalysis_apply_palette_title: "Aplicar paleta al atuendo",
    colorAnalysis_apply_palette_hint: "Haz clic en un color para aplicarlo",
    colorAnalysis_apply_color_aria: "Aplicar color {{color}}",
    colorAnalysis_target_item: "Artículo objetivo",
    colorAnalysis_powerColors_desc: "Estos colores esenciales proyectan tu máxima confianza y vitalidad.",
    colorAnalysis_admin_mode: "ADMIN",
    colorAnalysis_admin_analyzing: "Analizando conjunto curado...",
    colorAnalysis_admin_label: "Modo Admin:",
    colorAnalysis_admin_desc: "Sube una foto detallada del atuendo para extraer artículos y crear un conjunto Shop the Look.",
    colorAnalysis_admin_save_set: "Guardar en conjuntos curados",
    colorAnalysis_admin_shop_now: "Enlace Shop Now",
    colorAnalysis_admin_failed_analyze: "Error al analizar el conjunto",
    colorAnalysis_admin_failed_save: "Error al guardar.",
    colorAnalysis_admin_curated_saved: "¡Conjunto y artículos guardados localmente! (Refresca para ver en el guardarropa)",
    colorAnalysis_characteristic_skinTone: "Tono de piel:",
    colorAnalysis_characteristic_hairColor: "Color de cabello:",
    colorAnalysis_characteristic_eyeColor: "Color de ojos:",
    colorAnalysis_characteristic_faceShape: "Forma de la cara:",
    colorAnalysis_characteristic_bodySize: "Tamaño del cuerpo:",
    colorAnalysis_save_to_advice_title: "Análisis de color - {{season}}",
    colorAnalysis_unknown: "Desconocido",
    colorAnalysis_saved_to_profile_success: "Guardado en el perfil",
    myStylesPage_savedColorAnalysis_title: "Mis análisis de paleta de colores",
    myStylesPage_savedColorAnalysis_desc: "Tu historial de descubrimientos de colores personales y estacionalidad.",
    myStylesPage_noSavedAnalysis: "Aún no hay resultados de análisis de color guardados.",
    rss_source_constantina: "Constantina",
    stylingAdvisorPage_startChat: 'Iniciar Chat',
    myStylesPage_sourceOutfit: 'Fuente del Atuendo',
    myStylesPage_social_linkedin: 'LinkedIn',
    myStylesPage_social_twitter: 'Twitter',
    myStylesPage_social_instagram: 'Instagram',
    blog_post_not_found: 'Publicación no encontrada.',
    common_pdf: 'PDF',
    resource_category_style: 'Estilo',
    resource_category_color: 'Color',
    resource_category_business: 'Negocios',

    "rss_1_title": "Guía de Vogue para las tendencias de 2024",
    "rss_1_snippet": "Descubre las piezas clave que definen la estética de esta temporada.",
    "rss_2_title": "Lo mejor del Street Style",
    "rss_2_snippet": "Los mejores looks capturados en las calles de Milán y París.",
    "rss_3_title": "El Futuro del Calzado",
    "rss_3_snippet": "Los últimos lanzamientos y colaboraciones que definen la escena del calzado.",
    "rss_4_title": "Lujo Sostenible",
    "rss_4_snippet": "Cómo las marcas de alta gama están adoptando materiales ecológicos.",
    "rss_5_title": "Belleza Decodificada",
    "rss_5_snippet": "Las principales tendencias de belleza directamente desde la pasarela.",

    "campaign_new_year_title": "Año Nuevo, Estilo Nuevo",
    "campaign_new_year_desc": "Refresca tu look para el nuevo año.",
    "campaign_event_glamour_title": "Glamour de Eventos",
    "campaign_event_glamour_desc": "Brilla en tu próximo gran evento.",
    "campaign_executive_title": "Presencia Ejecutiva",
    "campaign_executive_desc": "Domina la sala con una imagen profesional poderosa.",
    "campaign_color_title": "Paleta Perfecta",
    "campaign_color_desc": "Descubre los colores que te hacen brillar.",
    "campaign_shopping_title": "Comprador Inteligente",
    "campaign_shopping_desc": "Piezas curadas que se adaptan perfectamente a tu estilo de vida.",
    "campaign_style_transformation_title": "Transformación Total",
    "campaign_style_transformation_desc": "Reinvéntate con nuestro taller de estilismo integral.",
    "campaign_summer_title": "Estilo Radiante de Verano",
    "campaign_summer_desc": "Abraza el sol con paletas vibrantes y siluetas transpirables.",
    "campaign_easter_title": "Renovación de Pascua",
    "campaign_easter_desc": "Refresca tu look con elegancia pastel y texturas estacionales.",

    "campaign_soft_power_title": "Revolución Soft Power",
    "campaign_soft_power_desc": "Adopta la estética ejecutiva de 2026: hombros redondeados, trajes pastel y sastrería fluida.",
    "campaign_sportif_chic_title": "Sportif Chic y Bienestar",
    "campaign_sportif_chic_desc": "La ropa deportiva elevada se encuentra con el lujo diario. Tejidos técnicos con toques femeninos.",
    "campaign_badge_trending": "Tendencia",

    "campaign_badge_limited_time": "Tiempo Limitado",
    "campaign_badge_events": "Especial de Temporada",
    "campaign_badge_professional": "Profesional",
    "campaign_badge_bestseller": "Más Vendido",
    "campaign_badge_seasonal": "Estacional",
    "campaign_badge_exclusive": "Exclusivo",
    "campaign_included_services": "Servicios Incluidos",

    "wardrobe_searchPlaceholder": "Buscar artículos...",
    "price_basic_weekly": "9,99 €/semana",
    "price_basic_monthly": "29,99 €/mes",
    "price_basic_quarterly": "79,99 €/trimestre",
    "price_premium_weekly": "19,99 €/semana",
    "price_premium_monthly": "59,99 €/mes",
    "price_premium_quarterly": "159,99 €/trimestre",
    "price_advanced_weekly": "39,99 €/semana",
    "price_advanced_monthly": "119,99 €/mes",
    "price_advanced_quarterly": "319,99 €/trimestre",
    "price_nextgen_weekly": "4,99 €/semana",
    "price_nextgen_monthly": "14,99 €/mes",
    "price_business_workshop_corporate": "5.000 €+",
    "price_style_transformation_essential": "450 €",
    "price_style_transformation_complete": "850 €",
    "price_style_transformation_vip": "1.500 €",
    "loading_updating_item": "Actualizando artículo...",
    "loading_updating_pose": "Cambiando pose a {{poseName}}...",
    "loading_updating_background": "Actualizando fondo...",
    "loading_updating_3d": "Generando vista 3D ({{current}}/4)...",
    "error_update_outfit": "Error al actualizar el atuendo. {{details}}",
    "error_save_outfit": "Error al guardar el atuendo. {{details}}",
    "common_user": "Usuario",
    "common_back": "Atrás",
    "common_next": "Siguiente",
    "canvas_colorPicker_title": "Selector de color",
    "wardrobe_item_tooltip_locked": "Bloqueado: requiere membresía {{level}}.",
    "wardrobe_item_tooltip_category": "Categoría: {{category}}",
    "wardrobe_item_tooltip_color": "Color predeterminado: {{color}}",
    "wardrobe_brand_ai_generated": "Generado por IA",
    "wardrobe_item_ai_name_prefix": "IA: {{prompt}}",

    // Capsule Generator
    "capsuleGenerator_title": "Generador de Armario Cápsula IA",
    "capsuleGenerator_subtitle": "Crea un armario versátil y cohesivo adaptado a tu estilo y a la ocasión.",
    "capsuleGenerator_premium_required": "Esta herramienta avanzada de estilismo IA está disponible para nuestros miembros Premium y Advanced.",
    "capsuleGenerator_select_season": "Seleccionar Temporada",
    "capsuleGenerator_select_occasion": "Seleccionar Ocasión",
    "capsuleGenerator_generate_btn": "Generar Cápsula",
    "capsuleGenerator_generating": "Diseñando tu cápsula...",
    "capsuleGenerator_season_spring": "Primavera",
    "capsuleGenerator_season_summer": "Verano",
    "capsuleGenerator_season_autumn": "Otoño",
    "capsuleGenerator_season_winter": "Invierno",
    "capsuleGenerator_occasion_work": "Ropa Profesional",
    "capsuleGenerator_occasion_casual": "Casual de Fin de Semana",
    "capsuleGenerator_occasion_travel": "Viajes y Vacaciones",
    "capsuleGenerator_occasion_formal": "Eventos Formales",
    "capsuleGenerator_result_palette": "Paleta de Colores",
    "capsuleGenerator_result_items": "Piezas Clave",
    "capsuleGenerator_result_combinations": "Combinaciones de Atuendos",
    "capsuleGenerator_seo_title": "Generador de Armario Cápsula IA | Constantina Lifestyle",
    "capsuleGenerator_seo_desc": "Genera un armario cápsula personalizado basado en tu estación de color, tipo de cuerpo y persona de estilo usando IA avanzada.",
    "capsuleGenerator_seo_keywords": "armario cápsula, estilista IA, planificación de moda, armario minimalista, análisis de estación de color",

    // Retail Search
    "retailSearchModal_title": "Buscar Artículos Similares",
    "retailSearchModal_titleForGarment": "Similar a: {{garmentName}}",
    "retailSearchModal_close": "Cerrar",
    "retailSearchModal_refine_title": "Refinar Búsqueda",
    "retailSearchModal_refine_color": "Color",
    "retailSearchModal_refine_pattern": "Patrón",
    "retailSearchModal_refine_material": "Material",
    "retailSearchModal_refine_color_placeholder": "ej. Azul Marino",
    "retailSearchModal_refine_pattern_placeholder": "ej. Rayas",
    "retailSearchModal_refine_material_placeholder": "ej. Seda",
    "retailSearchModal_refine_button": "Actualizar Búsqueda",
    "retailSearchModal_loading": "Buscando en minoristas globales...",
    "retailSearchModal_noResults": "No se encontraron artículos similares.",
    "retailSearchModal_sources": "Fuentes",
    "retailSearchModal_noPreview": "Sin Vista Previa",
    // ... existing translations
    "appName": "Constantina",
    "nav_home": "Inicio",
    "nav_about": "Sobre Nosotros",
    "nav_portfolio": "Portafolio",
    "nav_blog": "Blog",
    "nav_services": "Servicios",
    "nav_bookSession": "Reservar Sesión",
    "nav_dressingRoom": "Probador",
    "nav_myStyles": "Mis Estilos",
    "nav_advisor": "Asesor de Estilo",
    "nav_trends": "Tendencias",
    "nav_privacy": "Privacidad",
    "nav_terms": "Términos",
    "nav_impressum": "Aviso Legal",
    "nav_startOver": "Empezar de Nuevo",
    "nav_save": "Guardar",
    "nav_share": "Compartir",
    "nav_findSimilar": "Buscar Similares",
    "nav_getStyleTip": "Obtener Consejos",
    "trend_tag_heritage": "Herencia",
    "trend_tag_sculpted": "Escultural",
    "trend_tag_heritage_fusion": "Fusión Herencia",
    "trend_tag_ai_vision": "Visión IA",
    "trend_tag_emerging": "Emergente",
    "trend_tag_alpine_chic": "Chic Alpino",
    "trend_tag_cyber_soft": "Cyber Soft",
    "trend_tag_poet_core": "Poet Core",
    "trend_tag_glamoratti": "Glamoratti",
    "trend_tag_guardian": "Guardian",
    "trend_alpha_cyber_soft_title": "Fusión Pastel Digital",
    "trend_z_poet_core_title": "Romántico Académico",
    "trend_millennial_glamoratti_title": "Opulencia de los 80 Redux",
    "trend_classic_guardian_title": "Elegancia Protectora",
    "nav_lookbook": "Lookbook",
    "nav_lightMode": "Modo Claro",
    "nav_darkMode": "Modo Oscuro",
    "nav_switchUser": "Cambiar Usuario",
    "nav_profile": "Perfil",
    "nav_wardrobe": "Guardarropa",
    "nav_outfit": "Conjunto",
    "nav_guestCta": "Inicia sesión para acceder",
    "nav_show_wardrobe": "Mostrar Guardarropa",
    "nav_hide_wardrobe": "Ocultar Guardarropa",
    "nav_show_outfit": "Mostrar Conjunto",
    "nav_hide_outfit": "Ocultar Conjunto",
    "nav_signInGoogle": "Iniciar con Google",
    "nav_signInFacebook": "Iniciar con Facebook",
    "nav_rememberMe": "Recuérdame",
    "nav_signUp": "Registrarse",
    "nav_emailPlaceholder": "Correo",
    "nav_passwordPlaceholder": "Contraseña",
    "nav_signUpButton": "Crear Cuenta",
    "nav_continueWith": "O continuar con",
    "nav_guestUser": "(Invitado)",
    "nav_proceedToStyling": "Ir al Estilismo",
    "nav_help": "Centro de Ayuda",

    "footer_company": "Compañía",
    "footer_legal": "Legal",
    "footer_subscribe_title": "Mantente a la Moda",
    "footer_subscribe_desc": "Suscríbete a nuestro boletín para consejos exclusivos.",
    "footer_subscribe_placeholder": "Ingresa tu correo",
    "footer_subscribe_button_aria": "Suscribirse",
    "footer_subscribe_success": "¡Gracias por suscribirte!",
    "footer_subscribe_error": "Por favor ingresa un correo válido.",
    "footer_copyright": "Todos los derechos reservados.",
    "footer_createdBy": "Creado por",

    "portfolio.title": "Portafolio",
    "portfolio.description": "Una selección de nuestros mejores trabajos.",
    "portfolio.searchPlaceholder": "Buscar en portafolio...",
    "portfolio.noResults.title": "No se encontraron proyectos",
    "portfolio.noResults.message": "Intenta con otros términos de búsqueda.",
    "portfolio_category_editorial": "Editorial",
    "portfolio_category_street": "Estilo Urbano",
    "portfolio_category_commercial": "Comercial",
    "portfolio_category_portraits": "Retratos",
    "portfolio_category_personal": "Estilo Personal",
    "portfolio_category_wardrobe": "Guardarropa",
    "portfolio_category_events": "Eventos",
    "portfolio_category_specialty": "Especial",
    "portfolio.item1.title": "Vogue Urbano",
    "portfolio.item1.desc": "Editorial City Chic",
    "portfolio.item2.title": "Ritmo Urbano",
    "portfolio.item2.desc": "Moda Callejera Contemporánea",
    "portfolio.item3.title": "Bruma de Verano",
    "portfolio.item3.desc": "Campaña Comercial",
    "portfolio.item4.title": "Musa Moderna",
    "portfolio.item4.desc": "Editorial de Alta Moda",
    "portfolio.item5.title": "Esencia Pura",
    "portfolio.item5.desc": "Retratos con Luz Natural",

    "socialCarousel_simulation_note": "* Feed de redes sociales simulado",

    "portfolioPage_service_personalStyling_title": "Estilo Personal",
    "portfolioPage_service_personalStyling_description": "Renovación completa de estilo.",
    "portfolioPage_service_wardrobeCuration_title": "Curación de Guardarropa",
    "portfolioPage_service_wardrobeCuration_description": "Optimiza tu armario.",
    "portfolioPage_service_eventStyling_title": "Estilo para Eventos",
    "portfolioPage_service_eventStyling_description": "El look perfecto para cualquier ocasión.",
    "portfolioPage_service_individualShopping_title": "Compras Personales",
    "portfolioPage_service_individualShopping_description": "Experiencia de compra curada.",
    "portfolioPage_service_makeupAdvisory_title": "Asesoría de Maquillaje",
    "portfolioPage_service_makeupAdvisory_description": "Belleza que complementa tu estilo.",
    "portfolioPage_service_colorAnalysis_title": "Análisis de Color",
    "portfolioPage_service_colorAnalysis_description": "Encuentra tu paleta perfecta.",
    "portfolioPage_service_premiumInPerson_title": "Premium en Persona",
    "portfolioPage_service_businessWorkshops_title": "Talleres Empresariales",
    "portfolioPage_service_businessWorkshops_description": "Mejora la imagen profesional de tu equipo.",
    "portfolioPage_service_styleTransformation_title": "Transformación de Estilo",
    "portfolioPage_service_styleTransformation_description": "Una reinvención completa de tu estilo personal.",
    "portfolioPage_package_essential": "Esencial",
    "portfolioPage_package_complete": "Completo",
    "portfolioPage_package_vip": "VIP",

    "styleReport_title": "Reporte de Estilo",
    "styleReport_generatedFor": "Generado para {{username}}",
    "styleReport_date": "Fecha",
    "styleReport_profile_title": "Perfil de Estilo",
    "styleReport_no_persona": "Aún no se ha generado una persona de estilo.",
    "styleReport_outfits_title": "Atuendos Guardados",
    "styleReport_lookbooks_title": "Lookbooks",
    "styleReport_plans_title": "Planes de Estilo",
    "styleReport_no_plans": "No hay planes de estilo guardados.",
    "styleReport_back": "Volver a Mis Estilos",
    "styleReport_print": "Imprimir Reporte",

    "agentWorkflow_title": "Agente de Estilo",
    "agentWorkflow_greeting": "¡Hola! Soy tu Agente de Estilo dedicado. Puedo ayudarte a encontrar artículos, reservar citas o crear contenido para redes sociales. ¿En qué estás pensando?",
    "agentWorkflow_error_noItemsFound": "No pude encontrar artículos similares en este momento.",
    "agentWorkflow_fallback": "No entendí eso. Intenta pedir 'encontrar artículos similares' o 'reservar una sesión'.",
    "agentWorkflow_error": "Lo siento, ocurrió un error.",
    "agentWorkflow_thinking": "Procesando...",
    "agentWorkflow_placeholder": "Escribe una solicitud...",
    "agentWorkflow_socialMediaSavedTitle": "Contenido de Redes Sociales",

    "trendSpotter.greeting": "¿Listo para estar a la vanguardia? Soy tu Cazador de Tendencias. ¡Pregúntame sobre los últimos éxitos de la pasarela, estilos callejeros virales o qué colores dominan esta temporada!",
    "trendSpotter.cleared": "Historial de chat borrado.",
    "trendSpotter.thinking": "Analizando tendencias globales...",
    "trendSpotter.placeholder": "Pregunta sobre tendencias emergentes...",

    "homePage_businessStyling": "Estilo Empresarial",
    "homePage_cta": "Prueba Virtual",
    "loading_rendering": "Renderizando detalles...",
    "loading_generating_model": "Creando el nuevo tú...",
    "homePage_bookConsultation": "Reservar Consulta",
    "homePage_uploadInput_label": "Sube tu foto",
    "homePage_visionTitle": "Nuestra Visión",
    "homePage_vision_time_title": "Ahorra Tiempo",
    "homePage_vision_time_desc": "Visualización instantánea.",
    "homePage_vision_quality_title": "Calidad Primero",
    "homePage_vision_quality_desc": "Resultados de alta fidelidad.",
    "homePage_vision_digitalTwin_title": "Gemelo Digital",
    "homePage_vision_digitalTwin_desc": "Tu yo virtual.",
    "homePage_transformation_title": "Transformación",
    "homePage_transformation_desc": "Ve la diferencia.",
    "aboutPage_socialText": "Mantente al día con nuestras últimas tendencias.",
    "about_usp_title": "¿Por qué Constantina?",
    "about_usp_1_title": "IA centrada en el ser humano",
    "about_usp_1_desc": "La eficiencia de Ai combinada con la intuición de estilistas expertos.",
    "about_usp_2_title": "Tendencias basadas en datos",
    "about_usp_2_desc": "Análisis en tiempo real de las tendencias globales de las principales capitales de la moda.",
    "about_usp_3_title": "Branding Personal",
    "about_usp_3_desc": "No solo te vestimos; te ayudamos a proyectar tu yo más auténtico.",
    "about_usp_4_title": "Alcance Global",
    "about_usp_4_desc": "Estilismo de alta gama accesible, sin importar en qué parte del mundo te encuentres.",
    "about_certification_title": "Nuestras Certificaciones",
    "about_certification_desc": "Experiencia reconocida por las principales instituciones de la moda.",
    "aboutPage_certified_milano": "Master en Fashion Styling - Milán",
    "aboutPage_certified_london": "Comunicación de Moda - Londres",
    "booklet_minimalist_title": "Guía del Guardaroba Minimalista",
    "booklet_minimalist_desc": "Domina el arte de construir un guardarropa versátil y de alta calidad con menos piezas.",
    "booklet_color_theory_title": "Esenciales de la Teoría del Color",
    "booklet_color_theory_desc": "Descubre tu paleta de colores perfecta y aprende a crear conjuntos armoniosos.",
    "booklet_executive_title": "Estilismo de Presencia Ejecutiva",
    "booklet_executive_desc": "Guía de estilismo profesional para fortalecer tu autoridad a través de tu guardarropa.",
    "booklet_capsule_title": "El Plan del Guardarropa Cápsula",
    "booklet_capsule_desc": "Guía completa para crear colecciones cápsula estacionales que funcionan juntas.",
    "booklet_downloading": "Descargando",
    "aboutPage_title": "El Arte del Estilismo se une a la Inteligencia Artificial",
    "aboutPage_tagline": "Cerrando la brecha entre la elegancia atemporal y la tecnología de moda de vanguardia.",
    "aboutPage_paragraph1": "Fundada en el corazón de Suiza, Constantina nació de una única visión: democratizar la consultoría de imagen más sofisticada del mundo. Creemos que el verdadero estilo es más que solo ropa—es un activo estratégico y una forma poderosa de autoexpresión, accesible para todos a través de la fusión de la experiencia humana y la tecnología de IA avanzada.",
    "aboutPage_paragraph2": "Hoy en día, nuestra plataforma sirve como un conserje de estilo personal global, permitiendo a las personas navegar su presencia profesional y personal con la confianza de un maestro sastre, respaldado por la precisión de la IA generativa.",
    "aboutPage_missionText": "El estilo es el lenguaje silencioso de la identidad. Nuestra misión es brindarte las herramientas para hablarlo con fluidez, con absoluta confianza e impacto estratégico, en cualquier parte del mundo.",
    "aboutPage_techTitle": "La Inteligencia detrás del Arte",
    "aboutPage_techText_p1": "Utilizamos los modelos multimodales más avanzados—IA y posteriores—para realizar análisis visuales en tiempo real de prendas, texturas y siluetas.",
    "aboutPage_techText_p2": "Cada recomendación se basa en principios de estilismo profesional, teoría del color y contextos históricos de la moda, asegurando que nuestra IA siga siendo una herramienta de elevación, no solo de automatización.",
    "aboutPage_teamTitle": "Nuestros Visionarios",
    "aboutPage_socialTitle": "Conéctate con nuestro Futuro",
    "author_elara_vance_name": "Constantina",
    "author_elara_vance_bio": "Veterana de las casas de moda de Milán con una profunda pasión por la intersección de la tecnología y el estilismo tradicional.",
    "elara-vance_role": "Directora Creativa",
    "author_julian_sinclair_name": "Hannes",
    "author_julian_sinclair_bio": "Especializado en ética de la IA y patrones de procesamiento visual, asegurando que nuestro estilismo siga siendo humano e intuitivo.",
    "julian-sinclair_role": "Jefe de Arquitectura de IA",
    "author_heidi_steiner_name": "Heidi Steiner",
    "author_heidi_steiner_bio": "Aporta años de experiencia en conserjería de boutiques de alta gama a la esfera digital.",
    "heidi-steiner_role": "Conserje en Jefe",
    "author_lukas_weber_name": "Lukas Weber",
    "author_lukas_weber_bio": "Centrado en los datos de moda sostenible y la transparencia de abastecimiento en la era digital.",
    "lukas-weber_role": "Responsable de Sostenibilidad",
    "contact_title": "Conectemos",
    "contact_subtitle": "¿Tienes preguntas sobre nuestro estilismo con IA o quieres reservar un taller personalizado? Contáctanos y te responderemos en un plazo de 24 horas.",
    "contact_info_title": "Detalles de Contacto",
    "contact_email_label": "Correo",
    "contact_phone_label": "Teléfono",
    "contact_office_label": "Oficina",
    "contact_follow_us": "Síguenos",
    "contact_success_title": "¡Mensaje Enviado!",
    "contact_success_desc": "Gracias por contactarnos. Constantina revisará tu mensaje y responderá en breve.",
    "contact_form_name": "Nombre",
    "contact_form_email": "Correo",
    "contact_form_subject": "Asunto",
    "contact_form_message": "Mensaje",
    "contact_form_submit": "Enviar Mensaje",
    "contact_form_placeholder_name": "Tu nombre",
    "contact_form_placeholder_email": "tu@email.com",
    "contact_form_placeholder_subject": "¿De qué se trata esto?",
    "contact_form_placeholder_message": "Cuéntanos cómo podemos ayudarte...",
    "contact_form_send_another": "Enviar otro mensaje",

    // Portfolio Page
    // The original first occurrence of these keys is removed as per instruction.

    // Booking Page


    stylingAdvisorPage_greeting: "¡Hola! Soy tu estilista personal de IA. ¿Cómo puedo ayudarte a mejorar tu estilo hoy?",
    stylingAdvisorPage_tagline: "Tu consultor de moda personal con IA.",
    stylingAdvisorPage_chatSection: "Chat",
    stylingAdvisorPage_agentSelectorLabel: "Elige un Agente",
    stylingAdvisorPage_planSectionTitle: "Plan de Estilo",
    stylingAdvisorPage_planSectionDescription: "Genera una hoja de ruta de estilo personalizada basada en tus preferencias.",
    stylingAdvisorPage_photoAnalysisSectionTitle: "Análisis de Color",
    stylingAdvisorPage_photoAnalysisSectionDescription: "Sube una foto para descubrir tu paleta de colores estacional.",
    stylingAdvisorPage_photoAnalysisButton: "Analizar mi Foto",
    stylingAdvisorPage_photoAnalysisSelectLabel: "Seleccionar de Atuendos Guardados",
    stylingAdvisorPage_agentsSectionTitle: "Agentes Automatizados",
    stylingAdvisorPage_agentsDashboardTitle: "Mis Agentes de Estilo Activos",
    stylingAdvisorPage_createAgent: "Crear Nuevo Agente",
    stylingAdvisorPage_noAgents: "Aún no has creado ningún agente automatizado.",
    stylingAdvisorPage_thinking: "Pensando...",
    stylingAdvisorPage_generatePlan: "Generar Plan",
    stylingAdvisorPage_regeneratePlan: "Regenerar",
    stylingAdvisorPage_saveSuccess: "¡Guardado!",
    stylingAdvisorPage_planSavedTitle: "Plan de Estilo {{duration}}",
    stylingAdvisorPage_placeholder: "Pide consejo...",
    stylingAdvisorPage_planDuration_weekly: "Semanal",
    stylingAdvisorPage_planDuration_monthly: "Mensual",
    stylingAdvisorPage_planDuration_quarterly: "Trimestral",
    stylingAdvisorPage_mandatory_fields_tooltip: "Completa tu Persona de Estilo en el Perfil para desbloquear.",
    stylingAdvisorPage_agent_styleQuestionnaire_name: "Cuestionario de Estilo",
    stylingAdvisorPage_agent_styleQuestionnaire_description: "Descubre tu persona de estilo única a través de preguntas y respuestas.",
    stylingAdvisorPage_agent_business_name: "Profesional de Negocios",
    stylingAdvisorPage_agent_business_description: "Consejos de ropa corporativa y smart-casual.",
    stylingAdvisorPage_agent_vogueEditor_name: "Editorial Chic",
    stylingAdvisorPage_agent_vogueEditor_description: "Moda de alta costura, audaz y que marca tendencia.",
    stylingAdvisorPage_agent_glamour_name: "Glamour de Alfombra Roja",
    stylingAdvisorPage_agent_glamour_description: "Ropa de noche y estilismo para ocasiones especiales.",
    stylingAdvisorPage_agent_locked_basic: "Se requiere Plan Básico",
    stylingAdvisorPage_agent_locked_premium: "Se requiere Plan Premium",
    stylingAdvisorPage_agent_locked_advanced: "Se requiere Plan Avanzado",
    stylingAdvisorPage_planError: "No se pudo generar el plan de estilo. Por favor, inténtalo de nuevo.",
    stylingAdvisorPage_questionnaire_wizard_lifestyle_outdoor: "¿Cuánto tiempo pasas al aire libre / fuera?",
    "bookingForm_success_message_email": "Su solicitud de reserva ha sido enviada. Por favor, compruebe su correo electrónico para la invitación del calendario.",

    styleBot_questionnaire_intro: "¡Hola! Para darte el mejor consejo, me gustaría saber: 1. Género 2. Forma del cuerpo 3. Forma de la cara 4. Temporada de color 5. Preferencia de estilo. ¡Puedes responder todo a la vez o uno por uno!",
    styleBot_chip_female: "Mujer",
    styleBot_chip_male: "Hombre",
    styleBot_chip_non_binary: "No binario",
    styleBot_chip_hourglass: "Cuerpo Reloj de Arena",
    styleBot_chip_pear: "Cuerpo Pera",
    styleBot_chip_rectangle: "Cuerpo Rectangular",
    styleBot_chip_athletic: "Complexión Atlética",
    styleBot_chip_oval_face: "Cara Ovalada",
    styleBot_chip_square_face: "Cara Cuadrada",
    styleBot_chip_round_face: "Cara Redonda",
    styleBot_chip_heart_face: "Cara en Forma de Corazón",
    styleBot_chip_winter: "Invierno",
    styleBot_chip_summer: "Verano",
    styleBot_chip_autumn: "Otoño",
    styleBot_chip_spring: "Primavera",
    styleBot_chip_minimalist: "Estilo Minimalista",
    styleBot_chip_boho: "Boho Chic",
    styleBot_chip_classic: "Estilo Clásico",
    styleBot_chip_streetwear: "Streetwear",

    styleAgent_modal_title: "Configurar Agente de Estilo",
    styleAgent_modal_desc: "Configura un agente automatizado para buscar tendencias y planificar atuendos para ti en segundo plano.",
    styleAgent_name_label: "Nombre del Agente",
    styleAgent_name_placeholder: "ej., Scout de Vacaciones de Verano",
    styleAgent_frequency_label: "Frecuencia",
    styleAgent_season_label: "Temporada Objetivo",
    styleAgent_focus_label: "Enfoque de Estilo",
    styleAgent_create_btn: "Activar Agente",
    styleAgent_freq_weekly: "Semanal",
    styleAgent_freq_monthly: "Mensual",

    "voucher_modal_title": "Comprar Vale de Regalo",
    "voucher_modal_success_title": "¡Vale Creado!",
    "voucher_modal_success_message": "Tu vale ha sido creado con éxito. Puedes copiar el código a continuación.",
    "voucher_modal_service_label": "Seleccionar Servicios",
    "voucher_modal_recipient_name_label": "Nombre del Destinatario",
    "voucher_modal_recipient_name_placeholder": "ej. Maria García",
    "voucher_modal_recipient_email_label": "Email del Destinataire",
    "voucher_modal_recipient_email_placeholder": "maria@ejemplo.com",
    "voucher_modal_message_label": "Mensaje Personal",
    "voucher_modal_message_placeholder": "Escribe una nota...",
    "voucher_modal_purchase_button": "Comprar Vale",
    "voucher_modal_purchasing": "Procesando...",
    "voucher_modal_copy_code": "Copiar Código",

    myStylesPage_title: 'Mis Estilos',
    myStylesPage_empty_title: "Aún no hay estilos",
    myStylesPage_empty_desc: "Crea atuendos en el Probador para verlos aquí.",
    myStylesPage_tab_outfits: "Atuendos Guardados",
    myStylesPage_tab_items: "Artículos de Guardarropa",
    myStylesPage_delete_confirm: "¿Estás seguro de que quieres eliminar este estilo?",
    myStylesPage_created_at: "Creado el",

    // Booking Page
    "bookingPage_title": "Reservar Consulta",
    "bookingPage_tagline": "Programa una sesión individual con nuestros expertos.",
    "bookingPage_service_personal": "Estilismo Personal",
    "bookingPage_service_wardrobe": "Revisión de Guardarropa",
    "bookingPage_service_shopping": "Personal Shopper",

    // Blog Page
    "blogPage_title": "Diario de Estilo",
    "blogPage_tagline": "Perspectivas, tendencias y consejos de expertos.",
    "blogPage_resources_title": "Recursos Exclusivos",
    "blogPage_resources_locked_msg": "Actualiza a Premium para acceder a nuestras guías de estilo.",
    "blogPage_resources_upgrade": "Actualizar Ahora",
    "blog_post_read_more": "Leer Más",
    "editorial_rss_title": "Noticias de la Industria",
    "editorial_rss_subtitle": "Feeds curados de las mejores publicaciones de moda.",

    // Canvas / Dressing Room
    "canvas_seo_title": "Probador Virtual - Constantina",
    "canvas_seo_desc": "Pruébate atuendos virtualmente con nuestra tecnología de IA. Tu estilista personal.",
    "canvas_seo_keywords": "Probador Virtual IA, Estilista Personal, Armario Digital, Moda Tech, Creador de Atuendos",
    "canvas_uploadToStart": "Sube una foto para empezar",
    "canvas_view3D": "Ver en 3D",
    "canvas_shopTheLook": "Comprar el Look",
    "canvas_favorite_add": "Añadir a Favoritos",
    "canvas_favorite_remove": "Eliminar de Favoritos",
    "sceneControl_title": "Controles de Escena",
    "sceneControl_background_label": "Fondo",
    "sceneControl_custom_bg_placeholder": "Describe un fondo...",
    "sceneControl_modelScale_label": "Escala del Modelo",
    "sceneControl_bg_studio": "Estudio",
    "sceneControl_bg_street": "Calle",
    "sceneControl_bg_nature": "Naturaleza",
    "sceneControl_bg_cafe": "Café",
    "sceneControl_bg_beach": "Playa",
    "aboutPage_contactUs": "Contáctanos",
    "legalPage_title": "Información Legal",
    "legalPage_tagline": "Términos, privacidad e información legal importante sobre nuestros servicios.",
    "seo_legal_title": "Información Legal - Términos y Privacidad",
    "seo_legal_description": "Lea nuestros términos de servicio, política de privacidad, política de cookies y aviso legal.",
    "seo_legal_kw1": "términos de servicio",
    "seo_legal_kw2": "política de privacidad",
    "seo_legal_kw3": "información legal",
    "seo_legal_kw4": "aviso legal",
    "legalPage_impressum_title": "Aviso Legal",
    "legalPage_terms_title": "Términos y Condiciones",
    "legalPage_terms_content": "<p>Al utilizar nuestro servicio, aceptas nuestros términos de procesamiento de activos digitales y contenido generado por IA.</p>",
    "legalPage_privacy_title": "Política de Privacidad",
    "legalPage_privacy_content": "<p>Valoramos tu privacidad. Tus datos biométricos y personales se procesan localmente donde sea posible y se aseguran con estándares de la industria.</p>",
    "legalPage_cookies_title": "Política de Cookies",
    "legalPage_cookies_content": "<p>Utilizamos cookies esenciales para mantener tu sesión y tus preferencias.</p>",
    "blogPage_resources_locked_title": "Desbloquear Contenido Premium",
    "portfolioPage_title": "Estilista IA Premium y Marca Personal",
    "portfolioPage_tagline": "Mejore su imagen profesional con nuestros paquetes de estilismo a medida y soluciones de marca ejecutiva.",
    "seo_services_title": "Servicios de estilismo Premium",
    "seo_services_description": "Reserva consultas de estilismo profesional, curación de vestuario y sesiones de marca ejecutiva.",
    "seo_services_kw1": "estilismo personal",
    "seo_services_kw2": "curación de vestuario",
    "seo_services_kw3": "consultoría de imagen",
    "seo_services_kw4": "prueba virtual",
    "portfolioPage_campaigns_title": "Campañas Actuales",
    "portfolioPage_campaigns_tagline": "Ofertas exclusivas por tiempo limitado.",
    "portfolioPage_membership_title": "Planes de Membresía",
    "portfolioPage_membership_tagline": "Desbloquea funciones y contenido exclusivos.",
    "portfolioPage_services_title": "Nuestros Servicios",
    "portfolioPage_all_categories": "Todas las Categorías",
    "portfolioPage_bookService": "Reservar Servicio",
    "membership_cycle_weekly": "Semanal",
    "membership_cycle_monthly": "Mensual",
    "membership_cycle_quarterly": "Trimestral",
    "membership_subscribe_button": "Suscríbete Ahora",
    "membership_cycle_free": "Gratis",
    "profilePage_membership_free": "Gratis",
    "membership_feature_free_1": "Descubrimiento de estilo estándar",
    "membership_feature_free_2": "Feed de estilo curado",
    "membership_feature_basic_1": "Acceso Estándar",
    "membership_feature_basic_2": "Vestuario Básico",
    "membership_feature_basic_3": "Pruebas Limitadas",
    "membership_feature_basic_4": "Soporte Comunitario",
    "membership_feature_premium_1": "Acceso Prioritario",
    "membership_feature_premium_2": "Vestuario Ilimitado",
    "membership_feature_premium_3": "Pruebas Ilimitadas",
    "membership_feature_premium_4": "Soporte por Email",
    "membership_feature_premium_5": "Contenido Exclusivo",
    "membership_feature_premium_style_tips": "Consejos de Estilo IA",
    "membership_feature_advanced_1": "Todas las funciones Premium",
    "membership_feature_advanced_2": "Consulta 1-a-1",
    "membership_feature_advanced_3": "Acceso Anticipado",
    "membership_feature_advanced_4": "Soporte VIP",
    "membership_feature_advanced_5": "Personal Shopper",
    "membership_feature_advanced_social_media": "Gen Contenido Social",
    "membership_feature_advanced_plan_integration": "Integración Plan Estilo",
    "membership_feature_advanced_automated_shopping": "Compra Automatizada",
    "membership_feature_nextgen_1": "Eco-Style Insights",
    "membership_feature_nextgen_2": "Alertas de Tendencias Sociales",
    "membership_feature_nextgen_3": "Guías de Thrifting Curadas",
    "membership_feature_nextgen_4": "Integración de Tendencias TikTok",
    "portfolio_feature_1hr_video_call": "Videollamada de 1h",
    "portfolio_feature_style_questionnaire": "Cuestionario de Estilo",
    "portfolio_feature_personalized_mood_board": "Mood Board Personalizado",
    "portfolio_feature_all_online_features": "Todas las funciones online",
    "portfolio_feature_virtual_try_on_session": "Sesión de Prueba Virtual",
    "portfolio_feature_ai_lookbook": "Lookbook IA",
    "portfolio_feature_retail_search": "Búsqueda Retail",
    "portfolio_feature_all_ai_features": "Todas las funciones IA",
    "portfolio_feature_in_person_consultation": "Consulta en persona",
    "portfolio_feature_hands_on_styling": "Estilismo práctico",
    "portfolio_feature_wardrobe_analysis": "Análisis de vestuario",
    "portfolio_feature_declutter_guide": "Guía de orden",
    "portfolio_feature_shopping_list": "Lista de compras",
    "portfolio_feature_ai_outfit_pairing": "Combinación de Atuendos IA",
    "portfolio_feature_seasonal_capsule": "Cápsula estacional",
    "portfolio_feature_event_consultation": "Consulta para eventos",
    "portfolio_feature_3_outfit_proposals": "3 propuestas de atuendo",
    "portfolio_feature_accessorizing_guide": "Guía de accesorios",
    "portfolio_feature_event_virtual_try_on": "Prueba virtual para eventos",
    "portfolio_feature_pose_variation_check": "Control de variaciones",
    "portfolio_feature_shopping_consultation": "Consulta de compras",
    "portfolio_feature_curated_shopping_list": "Lista de compras curada",
    "portfolio_feature_style_integration_session": "Sesión de integración",
    "portfolio_feature_ai_product_search": "Búsqueda de producto IA",
    "portfolio_feature_vto_shortlist": "Lista corta VTO",
    "portfolio_feature_makeup_video_call": "Videollamada de maquillaje",
    "portfolio_feature_product_recommendations": "Recomendaciones de productos",
    "portfolio_feature_technique_guide": "Guía de técnica",
    "portfolio_feature_ai_face_analysis": "Analyse facial IA",
    "portfolio_feature_virtual_makeup_try_on": "Prueba de maquillaje virtual",
    "portfolio_feature_color_consultation": "Consulta de color",
    "portfolio_feature_digital_palette": "Paleta digital",
    "portfolio_feature_outfit_color_guide": "Guía de color de atuendos",
    "portfolio_feature_ai_color_detection": "Detección de color IA",
    "portfolio_feature_interactive_palette": "Paleta interactiva",
    "portfolio_feature_team_style_guide": "Guía de estilo para equipos",
    "portfolio_feature_brand_identity_alignment": "Alineación de marca",
    "portfolio_feature_group_qa": "Preguntas y respuestas grupales",
    "portfolio_feature_executive_presence": "Presencia ejecutiva",
    "portfolio_feature_personal_shopping_day": "Día de personal shopping",
    "portfolio_feature_keynote_speech": "Charla magistral",
    "portfolio_feature_pop_up_styling": "Bar de estilismo pop-up",
    "portfolio_feature_wardrobe_edit": "Edición de Guardarropa",
    "portfolio_feature_style_guide": "Guía de Estilo",
    "portfolio_feature_personal_shopping": "Personal Shopping",
    "portfolio_feature_makeup_lesson": "Clase de Maquillaje",
    "portfolio_feature_follow_up": "Sesión de Seguimiento",
    "portfolio_feature_photoshoot": "Sesión de Fotos Profesional",
    "portfolio_feature_hair_consultation": "Consulta Capilar",
    "portfolio_feature_vip_concierge": "Conserjería VIP",

    "nav_user_status_current": "Actual",
    "nav_user_status_active": "Sesión activa",
    "nav_user_action_login": "Iniciar sesión",
    "nav_user_action_delete": "Eliminar usuario",
    "nav_admin_model_config": "Admin: Configuración del modelo",
    "nav_admin_gen_model": "Modelo de generación de imagen",
    "nav_admin_gen_model_desc": "Selecciona el modelo IA para la generación.",
    "nav_admin_model_flash": "Gemini 1.5 Flash (Predeterminado)",
    "nav_admin_model_pro": "Gemini 1.5 Pro (Alta calidad)",
    "nav_membership_recommended": "RECOMENDADO",
    "membership_most_popular": "Más popular",
    "nav_app_download_prefix_ios": "Descargar en el",
    "nav_app_store_ios": "App Store",
    "nav_app_download_prefix_android": "DISPONIBLE EN",
    "nav_app_store_android": "Google Play",

    "home_hero_title": "Domina tu estilo personal con precisión de IA",
    "home_hero_title_new": "Eleva tu presencia. Nunca más te preguntes qué ponerte.",
    "home_hero_subtitle": "Tu conserje de moda profesional de IA. Experimenta looks seleccionados adaptados a tu paleta única, forma corporal y voz de marca personal.",
    "home_hero_cta": "Comenzar sesión de estilismo",
    "home_how_it_works_title": "Tu camino hacia la excelencia suiza y el estilo italiano",
    "home_how_it_works_step1_title": "1. Análisis visual de precisión",
    "home_how_it_works_step1_desc": "Comienza con un análisis visual que capture tu aura única. Nuestra IA de ingeniería suiza mapea tus proporciones con precisión quirúrgica.",
    "home_how_it_works_step2_title": "2. Visiones italianas curatadas",
    "home_how_it_works_step2_desc": "Explora recomendaciones curatadas con un ojo italiano para el detalle, asegurando que cada combinación emane 'Sprezzatura' y confianza.",
    "home_how_it_works_step3_title": "3. Curaduría experta y maestría",
    "home_how_it_works_step3_desc": "El toque final de la maestría humana. Reserva con nuestros estilistas expertos para finalizar tu transformación con atención personal.",
    "home_seo_title": "Constantina | Probador virtual IA y estilista personal",
    "home_seo_desc": "Transforma tu experiencia de compra con nuestro probador virtual IA. Descubre tu identidad de estilo con las tendencias de 2026 como Transformative Teal y Quiet Luxury.",
    "home_seo_keywords": "Probador virtual IA, Estilista personal, Armario digital, Fashion Tech, Creador de atuendos, Transformative Teal, Y2K Renaissance, Moda sostenible, Stealth Wealth, Tendencias de moda 2026",
    "home_empathy_title": "El estilo es personal. Lo entendemos.",
    "home_empathy_desc": "Creemos que la moda debe empoderar, no intimidar. Nuestra IA aprende tus preferencias únicas, tu cuerpo y tu estilo de vida para ofrecerte recomendaciones que se sientan auténticamente tuyas — no un algoritmo persiguiendo tendencias.",
    "home_press_title": "Destacado en",
    "profilePage_measurements_colorSeason_label": "Perfil de color (Temporada)",
    "profilePage_measurements_ai_auto_detect": "Autodetección por IA",
    "profilePage_stylePersona_analyzing_dna": "Analizando tu ADN de estilo...",

    "profile_seo_title": "Mi Perfil - Constantina",
    "profile_seo_desc": "Gestiona tu persona de estilo, suscripción y configuración de cuenta en Constantina.",
    "profile_seo_keywords": "perfil de usuario, persona de estilo, configuración de cuenta, Constantina",

    "canvas_result_alt": "Resultado del probador virtual",
    "pressPage_title": "Prensa y Colaboraciones",
    "pressPage_tagline": "Liderando la conversación en innovación de moda digital.",
    "pressPage_featured_title": "Visto en",
    "pressPage_partners_title": "Marcas Asociadas",
    "press_vogue_quote": "Redefine el estilismo personal con precisión de IA.",
    "press_harpers_quote": "El futuro del armario digital está aquí.",
    "press_elle_quote": "Una mezcla perfecta de tecnología y alta moda.",
    "press_brand1_desc": "Integración exclusiva de showroom digital.",
    "press_brand2_desc": "Alianza de prueba virtual.",
    "press_brand3_desc": "Colección cápsula curada.",
    "rss_source_vogue": "Vogue",
    "rss_source_elle": "Elle",
    "rss_source_harpers": "Harper's Bazaar",
    "rss_source_fashionista": "Fashionista",
    "rss_source_bof": "Business of Fashion",
    "rss_source_journelles": "Journelles",
    "rss_source_highsnobiety": "Highsnobiety",
    "rss_source_instyle": "InStyle",
    "rss_source_glamour": "Glamour",
    "rss_source_beige": "Beige",
    "rss_source_refinery29": "Refinery29",
    "rss_source_grazia": "Grazia",
    "rss_source_originalcopy": "The Original Copy",
    "rss_source_modepilot": "Modepilot",
    "rss_source_fashionunited": "FashionUnited",
    "rss_source_jolie": "Jolie",
    "rss_source_cosmopolitan": "Cosmopolitan",
    "rss_source_mashasedgwick": "Masha Sedgwick",
    "rss_source_ohhcouture": "Ohh Couture",
    "rss_source_carodaur": "Caro Daur",
    "rss_source_novalanalove": "Novalanalove",
    "payment_modal_select_method": "Seleccionar método de pago",
    "payment_method_card": "Tarjeta de crédito / débito",
    "payment_method_paypal": "PayPal",
    "payment_method_twint": "TWINT (Suiza)",
    "payment_method_sofort": "Sofort / Klarna (Alemania)",
    "payment_continue_to": "Continuar a {{method}}",
    "nav_logout": "Cerrar sesión",
    "generation_alpha": "Gen Alpha",
    "generation_z": "Gen Z",
    "generation_millennial": "Millennials",
    "generation_classic": "Clásico / Boomers",
    "trend_alpha_digital_twin_title": "Sincronización Digital Twin",
    "trend_alpha_gaming_couture_title": "Costura Meta-Gaming",
    "trend_z_y2k_redux_title": "Estética Y2K Redux",
    "trend_z_thrifting_elite_title": "Curaciones de Segunda Mano",
    "trend_millennial_80s_glam_title": "80s Power Glam",
    "trend_millennial_quiet_luxury_title": "Lujo Silencioso",
    "trend_classic_heritage_title": "Herencia al Aire Libre",
    "trend_tag_ai_native": "IA Nativa",
    "trend_tag_metaverse": "Metaverso",
    "trend_tag_nostalgia": "Nostalgia",
    "trend_tag_eco_conscious": "Eco-Elite",
    "trend_tag_sophisticated": "Sofisticado",
    "trend_tag_timeless": "Atemporal",
    "portfolio.alpha.title": "Identidades Digitales Gen Alpha",
    "portfolio.alpha.desc": "Uniendo skins virtuales con armarios de lujo físicos para la primera generación nativa digital.",
    "portfolio.z.title": "Individualidad Gen Z",
    "portfolio.z.desc": "Segunda mano impulsada por IA y detección de tendencias sociales para creadores de tendencias.",
    "portfolio.millennial.title": "Cúspide de Carrera Millennial",
    "portfolio.millennial.desc": "Glamour de los 80 elevado y lujo silencioso atemporal para el profesional moderno.",
    "trends_seo_title": "Tendencias de Moda 2026 | Constantina",
    "trends_seo_desc": "Explora las últimas tendencias de moda Gen Z y globales. Mantente a la vanguardia con insights impulsados por IA.",
    "trends_seo_keywords": "tendencias de moda, estilo gen z, moda 2026, detección de tendencias, moda sostenible",

    // Wardrobe & Outfit Stack (New)
    "wardrobe_category_Tops": "Partes de Arriba",
    "wardrobe_category_Jackets": "Chaquetas y Abrigos",
    "wardrobe_category_Outerwear": "Prendas de Abrigo",
    "wardrobe_category_Dresses": "Vestidos",
    "wardrobe_category_Bottoms": "Partes de Abajo",
    "wardrobe_category_Shoes": "Zapatos",
    "wardrobe_category_Bags": "Bolsos",
    "wardrobe_category_Eyewear": "Gafas",
    "wardrobe_category_Jewelry": "Joyas",
    "wardrobe_category_Other": "Accesorios y Otros",
    "wardrobe_category_All": "Todas las Categorías",

    "lifeSphere_selection_title": "Tu enfoque actual",
    "lifeSphere_selection_desc": "Selecciona tu Life Sphere activa para personalizar las recomendaciones.",
    "lifeSphere_executive_title": "Ascenso Ejecutivo",
    "lifeSphere_executive_desc": "Presencia profesional elevada y power dressing.",
    "lifeSphere_romantic_title": "Renacimiento Romántico",
    "lifeSphere_romantic_desc": "Estilismo seductor y seguro para tu vida amorosa.",
    "lifeSphere_matriarch_title": "Matriarca sin esfuerzo",
    "lifeSphere_matriarch_desc": "Elegancia chic y funcional para la vida familiar.",
    "lifeSphere_creative_title": "Florecimiento Creativo",
    "lifeSphere_creative_desc": "Siluetas audaces que reflejan el crecimiento artístico.",
    "wardrobe_tab_garments": "Prendas",
    "wardrobe_tab_accessories": "Accesorios",
    "wardrobe_tab_sets": "Conjuntos Curados",
    "wardrobe_upload_garment_title": "Añadir Nueva Prenda",
    "wardrobe_upload_accessory_title": "Añadir Nuevo Accesorio",
    "wardrobe_upload_garment": "Subir",
    "wardrobe_upload_accessory": "Subir",

    "outfitStack_title": "Composición del Atuendo",
    "outfitStack_undo": "Deshacer",
    "outfitStack_redo": "Rehacer",
    "outfitStack_empty_prompt": "Selecciona artículos de tu armario para empezar.",
    "outfitStack_changeColor_aria": "Cambiar color de {{itemName}}",
    "outfitStack_adjust_aria": "Ajustar {{itemName}}",
    "outfitStack_remove_aria": "Quitar {{itemName}}",
    "outfitStack_findSimilar_aria": "Buscar artículos similares a {{itemName}}",
    "outfitStack_findSimilar_main": "Comprar Similares",
    "outfitStack_addToLookbook": "Añadir al Lookbook",
    "outfitStack_suggestVariations": "Sugerir Variaciones",
    "outfitStack_analyzeColor": "Analizar Paleta",
    "outfitStack_creativeTools": "Herramientas Creativas",
    "outfitStack_saveOutfitFirstForLookbook": "Guarda el atuendo primero para añadirlo al lookbook",
    "alert_selectGarmentFirst": "Por favor, selecciona primero una prenda principal.",

    // Client Stories
    "testimonialsPage_title": "Historias de Clientes",
    "testimonialsPage_tagline": "Escucha a nuestra comunidad global de entusiastas del estilo.",
    "testimonialsPage_workInAction_title": "Trabajo en Acción",
    "testimonialsPage_workInAction_tagline": "Resultados reales de nuestras sesiones de estilismo y herramientas.",
    "testimonialsPage_workInAction_connectButton": "Conectar Redes Sociales",
    "testimonialsPage_workInAction_connecting": "Conectando...",
    "testimonialsPage_workInAction_youtubeTitle": "Cambios de Imagen YouTube",
    "testimonialsPage_workInAction_instagramTitle": "Reels de Instagram",
    "testimonialsPage_workInAction_twitterTitle": "Tweets de Estilo",
    "threeSixty_dragToRotate": "Arrastrar para rotar",

    // Testimonials
    "testimonial_name_1": "Sophie M.",
    "testimonial_location_paris": "París, Francia",
    "testimonial_quote_1": "Constantina transformó mi guardarropa. ¡Por fin sé qué colores me hacen brillar!",
    "testimonial_name_2": "Alessandro R.",
    "testimonial_location_milan": "Milán, Italia",
    "testimonial_quote_2": "La sesión de estilismo presencial cambió mi imagen profesional por completo.",
    "testimonial_name_3": "Emma W.",
    "testimonial_location_london": "Londres, Reino Unido",
    "testimonial_quote_3": "Organizar mi armario con las herramientas de IA hizo que la limpieza fuera divertida y efectiva.",
    "testimonial_name_4": "Wei L.",
    "testimonial_location_shanghai": "Shanghái, China",
    "testimonial_quote_4": "Usé el servicio de estilismo para eventos. Las recomendaciones fueron perfectas.",
    "testimonial_name_5": "Kenji T.",
    "testimonial_location_tokyo": "Tokio, Japón",
    "testimonial_quote_5": "La función Style Persona capturó mi estética mejor de lo que yo podría describir.",
    "testimonial_name_6": "Claire D.",
    "testimonial_location_montreal": "Montreal, Canadá",
    "testimonial_quote_6": "El probador virtual me ahorró mucho tiempo comprando en línea. ¡Muy recomendado!",
    "testimonial_name_7": "Elena G.",
    "testimonial_location_barcelona": "Barcelona, España",
    "testimonial_quote_7": "Me encantan los planes de estilo semanales. Quita el estrés de vestirse para el trabajo.",
    "testimonial_name_8": "Omar K.",
    "testimonial_location_dubai": "Dubái, EAU",
    "testimonial_quote_8": "Encontrar artículos similares mediante fotos es magia. Encontré una chaqueta que buscaba hace meses.",

    // Social Content
    "reel_1_caption": "¡Vibras de verano con nuestra nueva colección de lino! ☀️ #summerstyle",
    "reel_2_caption": "Lista para la temporada de galas. ✨ #eveningwear #glamour",
    "reel_3_caption": "Inspiración de street style desde Tokio. 🇯🇵 #streetwear",
    "youtube_1_title": "10 Esenciales de Armario",
    "youtube_1_published": "hace 2 días",
    "youtube_2_title": "Cómo combinar Blazers Oversize",
    "youtube_2_published": "hace 1 semana",
    "tweet_1_author": "Fashion Weekly",
    "tweet_1_text": "El regreso de la estética de los 90 llegó para quedarse. ¿Cuál es tu pieza retro favorita? 🧥",
    "tweet_1_timestamp": "hace 2h",
    "tweet_2_author": "Style Scout",
    "tweet_2_text": "Acabo de ver la nueva colección de Constantina. ¡Es fuego! 🔥",
    "tweet_2_timestamp": "hace 5h",

    // Lookbook & Social
    "lookbookCreatorModal_aspectRatio": "Relación de Aspecto",
    "lookbookCreatorModal_socialLayout": "Diseño Social (estilo Influencer)",
    "lookbookCreatorModal_socialLayoutDesc": "Optimizado para Instagram Stories y TikTok.",
    "lookbookCreatorModal_socialCaption": "Subtítulo Social IA",
    "lookbookCreatorModal_captionPlaceholder": "El subtítulo generado por IA aparecerá aquí...",
    "lookbookCreatorModal_download": "Descargar Imagen",
    "lookbookCreatorModal_error_enterName": "Por favor, introduce un nombre para tu lookbook.",

    // Profile Page
    "profilePage_measurements_title": "Medidas y Atributos",
    "profilePage_measurements_description": "Mantenga sus datos actualizados para mejores recomendaciones de ajuste.",
    "profilePage_personalDetails_title": "Detalles Personales",
    "profilePage_measurements_height": "Altura",
    "profilePage_measurements_weight": "Peso",
    "profilePage_measurements_chest": "Pecho",
    "profilePage_measurements_waist": "Cintura",
    "profilePage_measurements_hips": "Caderas",
    "profilePage_measurements_height_placeholder": "cm/ft",
    "profilePage_measurements_weight_placeholder": "kg/lbs",
    "profilePage_measurements_chest_placeholder": "cm/in",
    "profilePage_measurements_waist_placeholder": "cm/in",
    "profilePage_measurements_hips_placeholder": "cm/in",
    "profilePage_measurements_shoeSize": "Talla de Zapatos",
    "profilePage_measurements_shoeSize_placeholder": "ej. 42 / 9",
    "profilePage_attributes_detected_title": "Atributos Detectados",
    "profilePage_attributes_bodySize": "Tamaño Corporal",
    "profilePage_attributes_hairColor": "Color de Cabello",
    "profilePage_attributes_eyeColor": "Color de Ojos",
    "profilePage_attributes_faceShape": "Forma del Rostro",
    "profilePage_attributes_notDetected": "No detectado",
    "profilePage_preferredRetailers_label": "Minoristas Preferidos",
    "profilePage_preferredRetailers_description": "Seleccione las marcas que ama para mejores recomendaciones.",
    "profilePage_membership_title": "Membresía",
    "profilePage_membership_tagline": "Administre su plan de suscripción.",
    "profilePage_membership_level": "Plan Actual",
    "profilePage_membership_expiry_date": "Fecha de Vencimiento",
    "profilePage_membership_status_basic": "Básico",
    "profilePage_membership_status_active": "{{level}} - Activo hasta {{date}}",
    "profilePage_membership_status_active_no_date": "{{level}} - Activo",
    "profilePage_membership_status_expired": "{{level}} - Expirado el {{date}}",
    "profilePage_membership_basic": "Básico",
    "profilePage_membership_premium": "Premium",
    "profilePage_membership_advanced": "Avanzado",
    "profilePage_membership_nextgen": "Acceso NextGen",
    "profilePage_membership_current": "Plan Actual",
    "profilePage_membership_change_hint": "Cambiable solo mediante pago de actualización",
    "profilePage_membership_upgrade": "Actualizar",
    "profilePage_membership_label": "Membresía",
    "profilePage_membership_month": "mes",
    "profilePage_membership_current_label": "Plan Actual",
    "profilePage_membership_upgrade_button": "Actualizar",
    "profilePage_mobileApp_title": "Lleva tu estilo a todas partes",
    "profilePage_mobileApp_description": "Como miembro premium, tienes acceso exclusivo a nuestra aplicación móvil. Gestiona tu armario, recibe sesiones informativas diarias y usa el Style Sandbox sobre la marcha.",
    "profilePage_mobileApp_qrTitle": "Escanear para descargar",
    "travelPage_seo_title": "Lista de Equipaje para Viajes de Lujo y Resort Wear",
    "travelPage_seo_desc": "Crea la lista de equipaje de lujo definitiva. Desde ropa de resort hasta básicos para escapadas urbanas, planifica tu viaje con recomendaciones de IA.",
    "travelPage_seo_keywords": "lista de equipaje de lujo, moda para viajes, ropa de vacaciones, armario chic, básicos de viaje, estilista de IA",
    "travelPage_diaries_title": "Diarios de Viaje",
    "travelPage_no_lookbooks": "No se encontraron lookbooks de viaje.",
    "travelPage_destination_label": "¿A dónde vas?",
    "travelPage_destination_placeholder": "ej. París, Tulum, Aspen",
    "travelPage_style_summer": "Verano / Playa",
    "travelPage_style_winter": "Invierno / Esquí",
    "travelPage_generating": "Curando el guardarropa...",
    "travelPage_generate_btn": "Generar lista de equipaje",
    "travelPage_result_title": "Tu Capsule para {{destination}}",
    "travelPage_save_diary": "Guardar en el diario",
    "travelPage_export_pdf": "Exportar PDF",
    "capsuleGenerator_empty_state": "Selecciona tus preferencias y haz clic en \"Generar\" para ver tu capsule personal.",
    "auth_coupon_placeholder": "Código de cupón (opcional)",
    "user_status_registered": "Registrado",
    "user_status_validated": "Pendiente de aprobación",
    "user_status_active": "Activo",
    "user_status_inactive": "Inactivo",
    "user_status_deleted": "Eliminado",
    "auth_pending_admin": "Cuenta pendiente de aprobación del administrador",
    "auth_pending_confirmation": "Por favor, confirma tu correo electrónico.",
    "auth_account_deactivated": "Esta cuenta ha sido desactivada.",

    // Style Discovery Wizard
    "stylingAdvisorPage_questionnaire_wizard_title": "Asistente de Descubrimiento de Estilo",
    "stylingAdvisorPage_questionnaire_wizard_success": "¡Tu persona de estilo ha sido descubierta!",
    "stylingAdvisorPage_questionnaire_wizard_step_evolution": "¿Qué fase de desarrollo interior estás reflejando actualmente?",
    "stylingAdvisorPage_questionnaire_wizard_phase_emergence": "Emergencia",
    "stylingAdvisorPage_questionnaire_wizard_phase_leadership": "Liderazgo",
    "stylingAdvisorPage_questionnaire_wizard_phase_reclamation": "Reclamación",
    "stylingAdvisorPage_questionnaire_wizard_phase_transition": "Transición",
    "stylingAdvisorPage_questionnaire_wizard_phase_mastery": "Maestría",
    "stylingAdvisorPage_questionnaire_wizard_step_archetype": "¿Cuál es tu arquetipo de estilo actual?",
    "stylingAdvisorPage_questionnaire_wizard_arch_muse": "Musa",
    "stylingAdvisorPage_questionnaire_wizard_arch_warrior": "Guerrero",
    "stylingAdvisorPage_questionnaire_wizard_arch_creator": "Creador",
    "stylingAdvisorPage_questionnaire_wizard_arch_healer": "Sanador",
    "stylingAdvisorPage_questionnaire_wizard_arch_ruler": "Gobernante",
    "stylingAdvisorPage_questionnaire_wizard_arch_magician": "Mago",
    "stylingAdvisorPage_questionnaire_wizard_step_generation": "¿A qué generación perteneces?",
    "stylingAdvisorPage_questionnaire_wizard_gen_alpha": "Gen Alpha",
    "stylingAdvisorPage_questionnaire_wizard_gen_z": "Gen Z",
    "stylingAdvisorPage_questionnaire_wizard_gen_millennial": "Millennial",
    "stylingAdvisorPage_questionnaire_wizard_gen_x": "Gen X",
    "stylingAdvisorPage_questionnaire_wizard_gen_boomer": "Boomer",
    "stylingAdvisorPage_questionnaire_wizard_gen_classic": "Clásico",
    "stylingAdvisorPage_questionnaire_wizard_step_lifestyle": "Cuéntanos sobre tu estilo de vida",
    "stylingAdvisorPage_questionnaire_wizard_lifestyle_office": "¿Cuánto tiempo pasas en la oficina?",
    "stylingAdvisorPage_questionnaire_wizard_lifestyle_travel": "¿Cuánto viajas?",
    "stylingAdvisorPage_questionnaire_wizard_intensity_none": "Ninguna",
    "stylingAdvisorPage_questionnaire_wizard_intensity_low": "Baja",
    "stylingAdvisorPage_questionnaire_wizard_intensity_medium": "Media",
    "stylingAdvisorPage_questionnaire_wizard_intensity_high": "Alta",
    "stylingAdvisorPage_questionnaire_wizard_step_persona": "Selecciona tu persona de estilo",
    "stylingAdvisorPage_questionnaire_wizard_finish": "Descubre mi estilo",
    "homePage_solveStyleProblem_link": "Resolver un problema de estilo",
    "homePage_bookSession_link": "Reservar una sesión",
    "homePage_forCompanies_link": "Para empresas",
    "stylingAdvisorPage_questionnaire_wizard_persona_minimalist": "Minimalista",
    "stylingAdvisorPage_questionnaire_wizard_persona_bohoChic": "Boho Chic",
    "stylingAdvisorPage_questionnaire_wizard_persona_classicProfessional": "Clásico Profesional",
    "stylingAdvisorPage_questionnaire_wizard_persona_streetwear": "Streetwear",
    "stylingAdvisorPage_questionnaire_wizard_persona_avantGarde": "Vanguardista",
    "stylingAdvisorPage_questionnaire_wizard_persona_vintageRetro": "Vintage Retro",
    "stylingAdvisorPage_questionnaire_wizard_persona_activewear": "Ropa Deportiva",
    "stylingAdvisorPage_questionnaire_wizard_persona_glamorous": "Glamuroso"
  }
};
